(function() {
  const CFG = window.__SL_PRODUCT_CONFIG__;
  if (!CFG) return;

  const section = document.querySelector(`[data-section-id="${CFG.sectionId}"]`);
  if (!section) return;

  const productForm = section.querySelector('.sl-product-form');
  const variantSelect = section.querySelector('.sl-product-variant-select');
  const priceDisplay = section.querySelector('.sl-product-price-display');
  const gallerySlides = section.querySelectorAll('.sl-gallery-slide');
  const galleryThumbs = section.querySelectorAll('.sl-thumb');
  const optionInputs = section.querySelectorAll('.sl-product-option-input');
  const quantityButtons = section.querySelectorAll('.sl-product-quantity-btn');
  const bundleInputs = section.querySelectorAll('.sl-product-bundle-input, .sl-product-subscription-bundle-input');
  const carouselPrev = section.querySelector('.sl-carousel-prev');
  const carouselNext = section.querySelector('.sl-carousel-next');
  const carouselIndicators = section.querySelectorAll('.sl-indicator');

  const carouselPrevBelow = section.querySelector('.sl-carousel-prev-below');
  const carouselNextBelow = section.querySelector('.sl-carousel-next-below');
  const carouselThumbs = section.querySelectorAll('.sl-carousel-thumb');
  const carouselTrack = section.querySelector('.sl-carousel-track');

  const zoomableImages = section.querySelectorAll('.sl-zoomable');
  const zoomOverlay = document.getElementById(`sl-zoom-overlay-${CFG.sectionId}`);
  const zoomImage = document.getElementById(`sl-zoom-image-${CFG.sectionId}`);
  const zoomClose = zoomOverlay?.querySelector('.sl-zoom-close');
  const zoomPrev = zoomOverlay?.querySelector('.sl-zoom-prev');
  const zoomNext = zoomOverlay?.querySelector('.sl-zoom-next');
  const getZoomThumbs = () => zoomOverlay?.querySelectorAll('.sl-zoom-thumb') || [];
  const ZOOM_ENABLED = CFG.zoomEnabled;

  const subscriptionIdField = section.querySelector('.sl-product-subscription-id-field');
  const subscriptionServiceField = section.querySelector('.sl-product-subscription-service-field');
  const subscriptionIntervalField = section.querySelector('.sl-product-subscription-interval-field');
  const purchaseTypeField = section.querySelector('.sl-product-purchase-type-field');
  const buttonTextSingle = section.querySelector('.sl-product-button-text-single');
  const buttonTextSubscription = section.querySelector('.sl-product-button-text-subscription');
  
  let currentZoomIndex = 0;
  let totalImages = CFG.displayMediaSize;
  let zoomImages = CFG.zoomImages;
  
  const variantData = CFG.variantData;

  
        function getActiveLocale(section) {
      if (window.Shopify && Shopify.locale) return Shopify.locale;
      if (document.documentElement?.lang) return document.documentElement.lang;
      if (section?.dataset?.locale) return section.dataset.locale;
      return navigator.language || 'en';
    }

    function getActiveCurrency(section) {
      if (window.Shopify?.currency?.active) return Shopify.currency.active;
      if (window.Currency?.currentCurrency) return Currency.currentCurrency;
      const htmlCur = document.documentElement?.getAttribute('data-currency');
      if (htmlCur) return htmlCur;
      if (section?.dataset?.currency) return section.dataset.currency;
      return CFG.shopCurrency;
    }

    function formatPrice(priceInCents) {
      const locale = getActiveLocale(section);
      const currency = getActiveCurrency(section);
      const value = priceInCents / 100;

      try {
        const fmt = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol' // € statt EUR, CHF bleibt i. d. R. CHF
        });

        if (typeof fmt.formatToParts === 'function') {
          const parts = fmt.formatToParts(value);

          const cur = (parts.find(p => p.type === 'currency')?.value) || currency;

          const amount = parts
            .filter(p => p.type !== 'currency')
            .filter((p, i, arr) => !(p.type === 'literal' && (i === 0 || i === arr.length - 1)))
            .map(p => p.value)
            .join('')
            .trim();

          return `${cur} ${amount}`;
        }

        const formatted = fmt.format(value);

        const symbolMatch = formatted.match(/[^\d\s.,'’]+/);
        const symbol = symbolMatch ? symbolMatch[0] : currency;
        const amount = formatted.replace(symbol, '').trim();
        return `${symbol} ${amount}`;
      } catch (e) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          const fallback = Shopify.formatMoney(priceInCents, CFG.moneyFormat);

          return `${currency} ${fallback.replace(/[^\d\s.,'’]+/g, '').trim()}`;
        }
        return `${currency} ${(priceInCents / 100).toFixed(2)}`;
      }
    }

      
      function updatePriceDisplay(variant) {
        if (!priceDisplay) return;
        const priceEl = priceDisplay.querySelector('.sl-product-price-current');
        const compareEl = priceDisplay.querySelector('[data-compare-price]');
        const savingsEl = priceDisplay.querySelector('.sl-product-savings-badge');
        if (priceEl) {
          priceEl.textContent = formatPrice(variant.price);
          priceEl.dataset.price = variant.price;
        }
        const compareContainer = priceDisplay.querySelector('.sl-product-compare-price');
        if (compareEl && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatPrice(variant.compare_at_price);
          compareEl.dataset.comparePrice = variant.compare_at_price;
          if(compareContainer) compareContainer.style.display = 'block';
        } else if (compareContainer) {
          compareContainer.style.display = 'none';
        }
        if (savingsEl) {
          if (variant.compare_at_price > variant.price) {
            const savings = ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price;
            const savingsText = savingsEl.dataset.textTemplate.replace('[percent]', Math.round(savings));
            savingsEl.textContent = savingsText;
            savingsEl.style.display = 'inline-block';
          } else {
            savingsEl.style.display = 'none';
          }
        }
      }
  
  function updateBuyButtonState(variant) {
    const buyButton = section.querySelector('.sl-product-buy-button');
    if (!buyButton) return;
    buyButton.disabled = !variant.available;
    buyButton.textContent = variant.available ? buyButton.dataset.addText : buyButton.dataset.soldOutText;
  }
  
  function updateGallery(variant) {
    if (variant.featured_media) {
      const thumb = section.querySelector(`.sl-thumb[data-media-id="${variant.featured_media}"]`);
      const carouselThumb = section.querySelector(`.sl-carousel-thumb[data-media-id="${variant.featured_media}"]`);
      if (thumb) thumb.click();
      if (carouselThumb) carouselThumb.click();
    }
  }

  function updateVariantUrl(variantId) {
    if (variantId && window.history && window.history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({ path: url.href }, '', url.href);
    }
  }

  async function updateVariantGallery(variantId) {

    const enableVariantImages = CFG.enableVariantImages;

    if (!enableVariantImages) {

      return;
    }
    
    try {

      updateVariantUrl(variantId);

      const variant = variantData[variantId];

      if (!variant) {

        return;
      }

      const variantMedia = variant.variant_media;

      if (variantMedia && variantMedia.length > 0) {

        await rebuildGallery(variantMedia, true);
      } else {

        await rebuildGallery(null, false);
      }
    } catch (error) {

    }
  }

  const PRODUCT_MEDIA = CFG.productMedia;
  const MEDIA_BY_ID = PRODUCT_MEDIA.reduce((m, pm) => {
    m[String(pm.id)] = pm; 
    return m;
  }, {});

  function resolveMediaList(list) {
    if (!Array.isArray(list)) return [];
    return list.map((item) => {

      if (typeof item === 'string' || typeof item === 'number') {
        const key = String(item);

        if (MEDIA_BY_ID[key]) return MEDIA_BY_ID[key];

        return { id: key, media_type: 'image', preview_image: { src: key }, url: key };
      }

      if (item && (item.media_type || item.preview_image || Array.isArray(item.sources))) {

        if (item.id && MEDIA_BY_ID[String(item.id)]) {
          return Object.assign({}, MEDIA_BY_ID[String(item.id)], item);
        }
        return item;
      }

      if (item && item.id && item.image && item.image.src) {
        return { 
          id: item.id,
          media_type: 'image',
          preview_image: { src: item.image.src },
          alt: item.alt || ''
        };
      }

      return null;
    }).filter(Boolean);
  }

  async function rebuildGallery(mediaList, isVariantImages) {
    const galleryMain = section.querySelector('.sl-gallery-main');
    const galleryThumbs = section.querySelector('.sl-gallery-thumbs');
    const carouselTrack = section.querySelector('.sl-carousel-track');
    const zoomThumbs = zoomOverlay?.querySelector('.sl-zoom-thumbnails');
    
    if (!galleryMain) return;

    const imagesToUse = isVariantImages 
      ? resolveMediaList(mediaList) 
      : PRODUCT_MEDIA;
    
    if (!imagesToUse || imagesToUse.length === 0) return;

    const toStableId = (m) => (m && m.id) ? String(m.id)
      : (m && m.preview_image && m.preview_image.src) ? m.preview_image.src
      : (m && (m.src || m.url)) ? (m.src || m.url)
      : '';

    const mediaForZoom = imagesToUse.filter(m => (m.media_type || '').toLowerCase() === 'image');

    zoomImages = imagesToUse

    .filter((m) => {
      const t = (m && m.media_type) ? m.media_type :
                (m && m.host) ? 'external_video' :
                (m && Array.isArray(m?.sources)) ? 'video' : 'image';
      return t === 'image';
    })
    .map((m) => {
        const src = (typeof m === 'string') ? m
          : (m.preview_image && m.preview_image.src) ? m.preview_image.src
          : (m.src || m.url);
        return {
          id: toStableId(m),
          src,
          alt: (m && (m.alt || m.alt_text)) || ''
        };
      })
      .filter(z => z.id && z.src);

    totalImages = zoomImages.length;

    const slidesContainer = galleryMain.querySelector('.sl-gallery-slides-container');
    if (slidesContainer) {
      slidesContainer.innerHTML = '';
      imagesToUse.forEach((media, index) => {
        const slide = document.createElement('div');
        slide.className = `sl-gallery-slide ${index === 0 ? 'sl-active' : ''}`;
        slide.setAttribute('data-media-id', media.id);
        slide.setAttribute('data-image-index', index);

        let imageUrl;
        if (typeof media === 'string') {
          imageUrl = media;
        } else if (media.preview_image && media.preview_image.src) {
          imageUrl = media.preview_image.src;
        } else if (media.src) {
          imageUrl = media.src;
        } else if (media.url) {
          imageUrl = media.url;
        } else {

          return;
        }

        const type =
          (media && media.media_type) ? media.media_type :
          (media && media.host) ? 'external_video' :
          (media && Array.isArray(media.sources)) ? 'video' : 'image';

        const preview =
          (media && media.preview_image && media.preview_image.src) ||
          media?.src || media?.url || '';

        const badgeUrl = section.dataset.galleryBadge;
        const badgeHtml = (index === 0 && badgeUrl) ? `<img src="${badgeUrl}" class="sl-gallery-badge" alt="Product Badge">` : '';

        let slideHTML = '';

        if (type === 'image') {
          const zoomableClass = ZOOM_ENABLED ? ' sl-zoomable' : '';
          const zoomSrc = (media?.originalSrc || media?.src || media?.url || preview);
          const imgW = media?.width || media?.preview_image?.width || '';
          const imgH = media?.height || media?.preview_image?.height || '';
          const widthAttr = imgW ? `width="${imgW}"` : '';
          const heightAttr = imgH ? `height="${imgH}"` : '';

          function buildSrcset(url) {
            if (!url) return '';
            const widths = [400, 600, 800, 1000, 1200];
            return widths.map(w => {
              if (/[?&]width=/.test(url)) {
                return url.replace(/([?&])width=\d+/, `$1width=${w}`) + ` ${w}w`;
              }
              const sep = url.includes('?') ? '&' : '?';
              return `${url}${sep}width=${w} ${w}w`;
            }).join(', ');
          }
          const srcsetAttr = preview ? `srcset="${buildSrcset(preview)}"` : '';
          slideHTML = `
            <div class="sl-media-box">
            ${badgeHtml}
              <img
                src="${preview}"
                ${srcsetAttr}
                sizes="(min-width: 1200px) 600px, (min-width: 768px) 50vw, 100vw"
                alt="${media?.alt || ''}"
                class="sl-product-image${zoomableClass}"
                ${widthAttr}
                ${heightAttr}
                ${ZOOM_ENABLED ? `data-zoom-src="${zoomSrc}"` : ''}
                loading="${index === 0 ? 'eager' : 'lazy'}"
                ${index === 0 ? 'fetchpriority="high"' : ''}
                style="border-radius: ${CFG.borderRadius}px;"
              >
            </div>`;
        }

        else if (type === 'video') {
          const sources = (media.sources || [])
            .map(s => `<source src="${s.url}" type="${s.mime_type || 'video/mp4'}">`)
            .join('');
          slideHTML = `
            <div class="sl-media-box sl-media-video">
            ${badgeHtml}
              <video class="sl-product-video" controls playsinline
                    style="border-radius: ${CFG.borderRadius}px;">
                ${sources}
              </video>
            </div>`;
        }

        else if (type === 'external_video') {
          const embed = media.embed_url || preview;
          slideHTML = `
            <div class="sl-media-box sl-media-video">
            ${badgeHtml}
              <iframe class="sl-product-video-iframe"
                      src="${embed}" allowfullscreen
                      style="border-radius: ${CFG.borderRadius}px;">
              </iframe>
            </div>`;
        }

        else {
          slideHTML = `
            <div class="sl-media-box">
            ${badgeHtml}
              <img src="${preview}" alt="" class="sl-product-image"
                  style="border-radius: ${CFG.borderRadius}px;">
            </div>`;
        }

        slide.innerHTML = slideHTML;

        const stableId = media?.id || preview;
        slide.setAttribute('data-media-id', stableId);
        slidesContainer.appendChild(slide);
      });
    }

    const thumbnailContainers = [
      section.querySelector('.sl-gallery-thumbs'),
      section.querySelector('.sl-carousel-track'),
      zoomOverlay?.querySelector('.sl-zoom-thumbnails') // wichtig: echtes Overlay-Element
    ].filter(container => container);

    thumbnailContainers.forEach(container => {
      container.innerHTML = '';

      imagesToUse.forEach((media, index) => {

        const mediaType =
          (media && media.media_type) ? media.media_type :
          (media && media.host) ? 'external_video' :
          (media && Array.isArray(media.sources)) ? 'video' : 'image';

        const isZoom = container.classList.contains('sl-zoom-thumbnails');
        if (isZoom && mediaType !== 'image') return;

        let imageUrl;
        if (typeof media === 'string') {
          imageUrl = media;
        } else if (media.preview_image && media.preview_image.src) {
          imageUrl = media.preview_image.src;
        } else if (media.src) {
          imageUrl = media.src;
        } else if (media.url) {
          imageUrl = media.url;
        }
        if (!imageUrl) return;

        if (container.classList.contains('sl-gallery-thumbs')) {
          const thumb = document.createElement('button');
          thumb.className = `sl-thumb ${index === 0 ? 'sl-active' : ''}`;
          thumb.setAttribute('data-media-id', media.id);
          thumb.setAttribute('aria-label', `View image ${index + 1}`);
          thumb.innerHTML = `<img src="${imageUrl}" loading="lazy" alt="${media.alt || ''}">`;
          container.appendChild(thumb);

        } else if (container.classList.contains('sl-carousel-track')) {
          const carouselThumb = document.createElement('div');
          carouselThumb.className = `sl-carousel-thumb ${index === 0 ? 'sl-active' : ''}`;
          carouselThumb.setAttribute('data-media-id', media.id);
          carouselThumb.innerHTML = `<img src="${imageUrl}" alt="${media.alt || ''}">`;
          container.appendChild(carouselThumb);

        } else if (isZoom) {
          const zoomThumb = document.createElement('div');
          zoomThumb.className = `sl-zoom-thumb ${index === 0 ? 'sl-active' : ''}`;
          zoomThumb.setAttribute('data-media-id', media.id);
          zoomThumb.setAttribute('data-media-type', 'image');
          zoomThumb.innerHTML = `<img src="${imageUrl}" alt="${media.alt || ''}">`;
          container.appendChild(zoomThumb);
        }
      });
    });

    initializeGalleryEvents();
  }

  function initializeGalleryEvents() {

    const newGalleryMain = section.querySelector('.sl-gallery-main');
    
    if (newGalleryMain) {

      const gallery = new ProductGallery(newGalleryMain);

      const newThumbs = section.querySelectorAll('.sl-thumb, .sl-carousel-thumb, .sl-zoom-thumb');
      newThumbs.forEach(thumb => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const mediaId = thumb.dataset.mediaId;
          const slideIndex = Array.from(newThumbs).indexOf(thumb);

          newThumbs.forEach(t => t.classList.remove('sl-active'));
          thumb.classList.add('sl-active');

          gallery.goToSlide(slideIndex);
        });
      });

      if (CFG.zoomEnabled) {
        const zoomableImages = section.querySelectorAll('.sl-zoomable');
        zoomableImages.forEach(img => {
          img.addEventListener('click', (e) => {
            e.preventDefault();
            if (!zoomOverlay) return;
            const mediaId = img.closest('[data-media-id]')?.dataset.mediaId;

            const imageIndex = zoomImages.findIndex(z => String(z.id) === String(mediaId));

            const idx = imageIndex >= 0 ? imageIndex : 0;
            currentZoomIndex = idx;
            zoomImage.src = zoomImages[idx]?.src || '';
            zoomImage.alt = zoomImages[idx]?.alt || '';

            if (typeof updateZoomNavigation === 'function') updateZoomNavigation();
            zoomOverlay.style.display = 'flex';
            document.body.style.overflow = 'hidden';
          });
        });
      }
    }
  }

  function onVariantChange() {
    const selectedOptions = Array.from(optionInputs).filter(input => input.checked).map(input => input.value);
    let selectedVariant = null;
    for (const id in variantData) {
      if (JSON.stringify(variantData[id].options) === JSON.stringify(selectedOptions)) {
        selectedVariant = variantData[id];
        break;
      }
    }
    if (selectedVariant) {
      if (variantSelect) variantSelect.value = selectedVariant.id;
      const hiddenId = productForm.querySelector('input[name="id"]');
      if(hiddenId) hiddenId.value = selectedVariant.id;
      updatePriceDisplay(selectedVariant);
      updateBuyButtonState(selectedVariant);
      updateGallery(selectedVariant);

      updateVariantGallery(selectedVariant.id);

      updateStockWidget(selectedVariant.id);

      updatePreorderNote(selectedVariant);
    }
  }

  function updateStockWidget(variantId) {
    const stockWidgets = section.querySelectorAll('.sl-product-stock-widget');
    if (!stockWidgets.length) return;

    const v = variantData[variantId] || variantData[String(variantId)];
    if (!v) return;

    const mgmt      = (v.inventory_management || '').toString();   // 'shopify' | ''(null)
    const policy    = (v.inventory_policy || '').toString();       // 'continue' | 'deny' | ''
    const rawInv    = (typeof v.inventory_quantity === 'undefined') ? null : v.inventory_quantity;
    const inv       = (rawInv === null || rawInv === '') ? null : Number(rawInv);
    const available = !!v.available;
    const incoming  = String(v.incoming).toLowerCase() === 'true';

    stockWidgets.forEach((stockWidget) => {
      const ds = stockWidget.dataset;
      const truthy = (val) => /^(true|1|yes|on)$/i.test(String(val || '').trim());

      const boEnabled = truthy(ds.backorderEnabled);
      const boMode    = (ds.backorderDateMode || 'auto').toLowerCase(); // 'auto' | 'manual'
      const boManual  = ds.backorderManualDate || '';
      const boTpl     = ds.backorderTextTemplate || 'Vorbestellung – verfügbar ab [date]';
      const boColor   = ds.backorderColor || '#8a6cff';

      const lowTh   = Number(ds.lowStockThreshold ?? 5);
      const highTh  = Number(ds.highStockThreshold ?? 20);

      const txtHigh   = ds.highStockText   || '[count] auf Lager';
      const txtMed    = ds.mediumStockText || '[count] auf Lager';
      const txtLow    = ds.lowStockText    || 'Nur noch [count] verfügbar';
      const txtOut    = ds.outStockText    || 'Ausverkauft';

      const colHigh = ds.highStockColor   || '#27ae60';
      const colMed  = ds.mediumStockColor || '#2ea3f2';
      const colLow  = ds.lowStockColor    || '#f39c12';   // gelb
      const colOut  = ds.outStockColor    || '#e74c3c';

      const isBackorder =
        boEnabled &&
        (mgmt === 'shopify') &&
        (policy === 'continue') &&
        (inv !== null) && (inv <= 0);

      let boDate = '';
      if (isBackorder) {
        if (boMode === 'auto' && v.next_incoming_date) {
          const d = new Date(v.next_incoming_date);
          boDate = isNaN(d.getTime()) ? '' : d.toLocaleDateString('de-DE');
        } else if (boMode === 'manual' && boManual) {
          boDate = boManual;
        }
      }

      const current = stockWidget.querySelector('.sl-stock');
      const textColor = current ? (current.style.color || stockWidget.style.color || '#333') : (stockWidget.style.color || '#333');

      let html = '';
      if (isBackorder) {
        html = `
          <div class="sl-stock sl-product-stock--backorder" style="color:${textColor};">
            <span class="sl-product-stock-dot sl-dot-backorder" style="background:${boColor};"></span>
            ${boTpl.replace('[date]', boDate)}
          </div>`;
      } else {

        if (!available || inv === 0 || inv === null) {
          html = `
            <div class="sl-stock sl-product-stock--out" style="color:${textColor};">
              <span class="sl-product-stock-dot sl-dot-out" style="background:${colOut};"></span>
              ${txtOut}
            </div>`;
        } else if (inv > highTh) {
          html = `
            <div class="sl-stock sl-product-stock--high" style="color:${textColor};">
              <span class="sl-product-stock-dot sl-dot-high" style="background:${colHigh};"></span>
              ${txtHigh.replace('[count]', inv)}
            </div>`;
        } else if (inv > lowTh) {
          html = `
            <div class="sl-stock sl-product-stock--medium" style="color:${textColor};">
              <span class="sl-product-stock-dot sl-dot-medium" style="background:${colMed};"></span>
              ${txtMed.replace('[count]', inv)}
            </div>`;
        } else {
          html = `
            <div class="sl-stock sl-product-stock--low" style="color:${textColor};">
              <span class="sl-product-stock-dot sl-dot-low" style="background:${colLow};"></span>
              ${txtLow.replace('[count]', inv)}
            </div>`;
        }
      }

      stockWidget.innerHTML = html;
      stockWidget.setAttribute('data-variant-id', variantId);
    });
  }

  function updatePreorderNote(variant) {
    const input = section.querySelector('.js-preorder-note');
    if (!input || !variant) return;

    const isBackorder =
      variant.inventory_management === 'shopify' &&
      variant.inventory_quantity <= 0 &&
      variant.inventory_policy === 'continue' &&
      variant.next_incoming_date;

    if (isBackorder) {
      const date = new Date(variant.next_incoming_date)
        .toLocaleDateString('de-DE');

      input.value = `Vorbestellung – wird ab ${date} geliefert`;
    } else {

      input.value = '';
    }
  }

  class ProductGallery {
    constructor(galleryElement) {
      this.gallery = galleryElement;
      this.productSection = galleryElement.closest('.sl-enhanced-product') || 
                           galleryElement.closest('.sl-product-gallery') || 
                           galleryElement.closest('[class*="sl-section"]');

      this.slidesContainer = galleryElement.querySelector('.sl-gallery-slides-container');
      this.slides = galleryElement.querySelectorAll('.sl-gallery-slide');
      this.indicators = galleryElement.querySelectorAll('.sl-indicator');
      this.prevBtn = galleryElement.querySelector('.sl-gallery-prev, .sl-carousel-prev');
      this.nextBtn = galleryElement.querySelector('.sl-gallery-next, .sl-carousel-next');

      if (this.productSection) {

        const regularThumbnails = this.productSection.querySelectorAll('.sl-thumb');
        const carouselThumbnails = this.productSection.querySelectorAll('.sl-carousel-thumb');  
        const zoomThumbnails = this.productSection.querySelectorAll('.sl-zoom-thumb');

        this.allThumbnails = [...regularThumbnails, ...carouselThumbnails, ...zoomThumbnails];

        this.gridItems = this.productSection.querySelectorAll('.sl-gallery-grid-item');

        this.thumbnailCarousel = this.productSection.querySelector('.sl-gallery-thumbs') || 
                                this.productSection.querySelector('.sl-carousel-track');
      } else {
        this.allThumbnails = [];
        this.gridItems = [];
        this.thumbnailCarousel = null;
      }

      this.currentIndex = 0;
      this.isAnimating = false;
      this.isDragging = false;
      this.isScrolling = false;
      this.startX = 0;
      this.startY = 0;
      this.startTime = 0;
      this.swipeThreshold = 50;
      
      this.init();
    }
    
    init() {
      if (this.slides.length <= 1) return;
      
      this.preloadImages();
      this.bindEvents();
      this.goToSlide(0, false); // Initialize to first slide

      requestAnimationFrame(() => {
        const firstId = String(this.slides[0]?.dataset.mediaId || '');
        this.scrollThumbnailCarousel(0, firstId);
      });
      setTimeout(() => {
        const firstId = String(this.slides[0]?.dataset.mediaId || '');
        this.scrollThumbnailCarousel(0, firstId);
      }, 120);

      this.gallery._galleryInstance = this;
    }
    
    preloadImages() {
      this.slides.forEach((slide) => {
        const img = slide.querySelector('img');
        const loader = slide.querySelector('.sl-image-loader');
        
        if (img && img.dataset.src) {
          const tempImg = new Image();
          tempImg.onload = () => {
            img.src = img.dataset.src;
            img.classList.add('sl-loaded');
            if (loader) loader.style.display = 'none';
          };
          tempImg.onerror = () => {
            if (loader) loader.style.display = 'none';
          };
          tempImg.src = img.dataset.src;
        }
      });
    }

    goToSlide(index, animate = true) {
      if (this.isAnimating && animate) return false;

      index = Math.max(0, Math.min(index, this.slides.length - 1));
      
      if (index === this.currentIndex && animate) return false;

        const prevSlide = this.slides[this.currentIndex];
        this.pauseVideos(prevSlide);
      
      this.isAnimating = true;
      this.currentIndex = index;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('sl-active', i === index);
      });

      if (this.slidesContainer) {
        const translateX = -index * 100;
        this.slidesContainer.style.transition = animate ? 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
        this.slidesContainer.style.transform = `translateX(${translateX}%)`;
      }

      this.updateRelatedElements(index);

      setTimeout(() => {
        this.isAnimating = false;
      }, animate ? 400 : 0);
      
      return true;
    }
    
    updateRelatedElements(index) {

      const activeSlide = this.slides[index];
      const activeId = activeSlide ? String(activeSlide.dataset.mediaId || '') : '';

      const thumbContainers = [
        this.productSection?.querySelector('.sl-gallery-thumbs'),
        this.productSection?.querySelector('.sl-carousel-track')
      ].filter(Boolean);

      thumbContainers.forEach(container => {
        const thumbs = container.querySelectorAll('.sl-thumb, .sl-carousel-thumb');
        thumbs.forEach(t => t.classList.toggle('sl-active', String(t.dataset.mediaId || '') === activeId));
      });

      const zoomThumbs = this.productSection?.querySelectorAll('.sl-zoom-thumb') || [];
      zoomThumbs.forEach(t => t.classList.toggle('sl-active', String(t.dataset.mediaId || '') === activeId));

      this.scrollThumbnailCarousel(index, activeId);

      this.gridItems.forEach((item, i) => item.classList.toggle('sl-active', i === index));
      this.indicators.forEach((indicator, i) => indicator.classList.toggle('sl-active', i === index));
      if (this.prevBtn) this.prevBtn.disabled = index === 0;
      if (this.nextBtn) this.nextBtn.disabled = index === this.slides.length - 1;
    }
    
    scrollThumbnailCarousel(activeIndex, activeId) {
      const containers = [
        this.productSection?.querySelector('.sl-gallery-thumbs'),
        this.productSection?.querySelector('.sl-carousel-track'),
        this.productSection?.querySelector('.sl-gallery-thumbs-container .sl-gallery-thumbs')
      ].filter(Boolean);

      containers.forEach(container => {
        this.scrollThumbnailContainer(container, activeIndex, activeId);
      });
    }
    
    scrollThumbnailContainer(container, activeIndex, activeId) {
      if (!container) return;

      let activeThumb = activeId
        ? container.querySelector(`[data-media-id="${CSS.escape(String(activeId))}"]`)
        : null;

      if (!activeThumb) {
        const regularThumbnails = container.querySelectorAll('.sl-thumb');
        const carouselThumbnails = container.querySelectorAll('.sl-carousel-thumb');
        const allThumbnails = [...regularThumbnails, ...carouselThumbnails];
        activeThumb = allThumbnails[activeIndex] || allThumbnails[0];
      }
      if (!activeThumb) return;

      const cRect = container.getBoundingClientRect();
      const tRect = activeThumb.getBoundingClientRect();
      const center = (tRect.left - cRect.left) + (tRect.width / 2);
      const offset = center - (cRect.width / 2);

      const behavior = container.dataset._initialScrollDone ? 'smooth' : 'auto';
      container.scrollTo({ left: container.scrollLeft + offset, behavior });
      container.dataset._initialScrollDone = '1';
    }
    
    nextSlide() {
      if (this.currentIndex < this.slides.length - 1) {
        this.goToSlide(this.currentIndex + 1);
      }
    }
    
    prevSlide() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      }
    }
    
    bindEvents() {

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextSlide());
      }

      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => this.goToSlide(index));
      });

      this.allThumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const id = String(thumb.dataset.mediaId || '');

          const slides = Array.from(this.slides);
          const idx = Math.max(0, slides.findIndex(s => String(s.dataset.mediaId || '') === id));
          this.goToSlide(idx);
        });
      });

      this.gridItems.forEach((item, index) => {
        item.addEventListener('click', () => this.goToSlide(index));
      });

      const thumbPrevBtn = this.productSection.querySelector('.sl-thumb-prev');
      const thumbNextBtn = this.productSection.querySelector('.sl-thumb-next');
      if (thumbPrevBtn) {
        thumbPrevBtn.addEventListener('click', () => this.prevSlide());
      }
      if (thumbNextBtn) {
        thumbNextBtn.addEventListener('click', () => this.nextSlide());
      }

      this.gallery.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: false });
      this.gallery.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
      this.gallery.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });

      this.gallery.addEventListener('contextmenu', (e) => e.preventDefault());
    }
    
    handleTouchStart(e) {
      if (this.slides.length <= 1) return;
      
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.isDragging = false;
      this.isScrolling = false;
      this.startTime = Date.now();

      if (this.slidesContainer) {
        this.slidesContainer.style.transition = 'none';
      }
    }

    handleTouchMove(e) {
      if (this.slides.length <= 1 || this.isAnimating) return;
      
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const diffX = currentX - this.startX;
      const diffY = currentY - this.startY;

      if (!this.isDragging && !this.isScrolling) {
        if (Math.abs(diffX) > Math.abs(diffY)) {

          this.isDragging = true;
          e.preventDefault(); // Prevent vertical scroll
        } else {

          this.isScrolling = true;
          return;
        }
      }
      
      if (!this.isDragging) return;
      
      e.preventDefault();
      
      const slideWidth = this.gallery.offsetWidth;
      const progress = diffX / slideWidth;

      let targetIndex = this.currentIndex;
      let limitedProgress = progress;
      
      if (progress > 0 && this.currentIndex === 0) {

        limitedProgress = progress * 0.3;
      } else if (progress < 0 && this.currentIndex === this.slides.length - 1) {

        limitedProgress = progress * 0.3;
      }
      
      if (this.slidesContainer) {
        const baseTranslate = -this.currentIndex * 100;
        const currentTranslate = baseTranslate + (limitedProgress * 100);
        this.slidesContainer.style.transform = `translateX(${currentTranslate}%)`;
      }
    }

    handleTouchEnd(e) {
      if (this.slides.length <= 1 || this.isScrolling || !this.isDragging) {
        this.isDragging = false;
        this.isScrolling = false;
        return;
      }
      
      this.isDragging = false;
      
      const endX = e.changedTouches[0].clientX;
      const diffX = endX - this.startX;
      const slideWidth = this.gallery.offsetWidth;
      const swipeDistance = Math.abs(diffX);
      const swipeTime = Date.now() - this.startTime;

      const isQuickSwipe = swipeTime < 300 && swipeDistance > 30;
      const isLongSwipe = swipeDistance > slideWidth * 0.25; // 25% of slide width
      
      let newIndex = this.currentIndex;
      
      if (isQuickSwipe || isLongSwipe) {
        if (diffX > 0 && this.currentIndex > 0) {

          newIndex = this.currentIndex - 1;
        } else if (diffX < 0 && this.currentIndex < this.slides.length - 1) {

          newIndex = this.currentIndex + 1;
        }
      }

      this.goToSlide(newIndex, true);
    }

    pauseVideos(slide) {
      if (!slide) return;

      slide.querySelectorAll('video, audio').forEach(el => el.pause());

      slide.querySelectorAll('iframe').forEach(frame => {
        const src = frame.src || '';
        if (src.includes('youtube')) {
          frame.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":[]}', '*');
        }

        if (src.includes('vimeo')) {
          frame.contentWindow?.postMessage({ method: 'pause' }, '*');
        }
      });
    }

  }

  function getVariantFromUrl() {
    const url = new URL(window.location);
    return url.searchParams.get('variant');
  }

  function initializeVariantFromUrl() {
    const variantIdFromUrl = getVariantFromUrl();
    if (variantIdFromUrl) {

      const variantOption = section.querySelector(`input[value="${variantIdFromUrl}"]`);
      if (variantOption) {
        variantOption.checked = true;
        variantOption.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (variantSelect) {
        variantSelect.value = variantIdFromUrl;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  const galleries = document.querySelectorAll('[data-gallery-main]');
  galleries.forEach(gallery => {
    new ProductGallery(gallery);
  });

  initializeVariantFromUrl();

  const enableVariantImages = CFG.enableVariantImages;
  if (enableVariantImages) {

    const initialVariantId = getVariantFromUrl() || 
                           variantSelect?.value || 
                           document.querySelector('input[name="id"]')?.value ||
                           CFG.selectedVariantId;

    if (initialVariantId) {

      updateVariantGallery(initialVariantId);
    }
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      const activeGallery = document.querySelector('[data-gallery-main]');
      if (activeGallery && activeGallery._galleryInstance) {
        if (e.key === 'ArrowLeft') {
          activeGallery._galleryInstance.prevSlide();
        } else {
          activeGallery._galleryInstance.nextSlide();
        }
      }
    }
  });

  if (carouselPrevBelow && carouselNextBelow && carouselTrack) {
    let currentCarouselIndex = 0;
    const totalThumbs = carouselThumbs.length;
    let thumbWidth = 130;
    let maxIndex = 0;

    const calculateCarouselParams = () => {
      if (carouselThumbs.length > 0) {
        thumbWidth = carouselThumbs[0].offsetWidth + 10; // 10 is the gap
      }
      const containerWidth = carouselTrack.parentElement.offsetWidth;
      const visibleThumbs = Math.floor(containerWidth / thumbWidth);
      maxIndex = Math.max(0, totalThumbs - visibleThumbs);
    };

    const updateCarouselBelow = () => {
      calculateCarouselParams();
      const translateX = -(currentCarouselIndex * thumbWidth);
      carouselTrack.style.transform = `translateX(${translateX}px)`;

      const showArrows = carouselTrack.scrollWidth > carouselTrack.parentElement.offsetWidth;
      carouselPrevBelow.style.display = showArrows ? 'flex' : 'none';
      carouselNextBelow.style.display = showArrows ? 'flex' : 'none';

      if (showArrows) {
        carouselPrevBelow.style.visibility = currentCarouselIndex === 0 ? 'hidden' : 'visible';
        carouselNextBelow.style.visibility = currentCarouselIndex >= maxIndex ? 'hidden' : 'visible';
      }
    };
    
    carouselPrevBelow.addEventListener('click', () => { 
      if (currentCarouselIndex > 0) {
        currentCarouselIndex--; 
        updateCarouselBelow(); 
      }
    });
    carouselNextBelow.addEventListener('click', () => { 
      if (currentCarouselIndex < maxIndex) {
        currentCarouselIndex++; 
        updateCarouselBelow(); 
      }
    });
    
    updateCarouselBelow();

    window.addEventListener('resize', () => {
      const newContainerWidth = carouselTrack.parentElement.offsetWidth;
      const newVisibleThumbs = Math.floor(newContainerWidth / thumbWidth);
      const newMaxIndex = Math.max(0, totalThumbs - newVisibleThumbs);
      if (currentCarouselIndex > newMaxIndex) {
        currentCarouselIndex = newMaxIndex;
      }
      updateCarouselBelow();
    });
  }

  if (ZOOM_ENABLED) {
    const updateZoomNavigation = () => {
      if (zoomPrev && zoomNext) {
        zoomPrev.style.visibility = currentZoomIndex === 0 ? 'hidden' : 'visible';
        zoomNext.style.visibility = currentZoomIndex === totalImages - 1 ? 'hidden' : 'visible';

        const showArrows = totalImages > 1;
        zoomPrev.style.display = showArrows ? 'flex' : 'none';
        zoomNext.style.display = showArrows ? 'flex' : 'none';
      }

      const thumbsNow = getZoomThumbs();
      thumbsNow.forEach((thumb, index) => {
        thumb.classList.toggle('sl-active', index === currentZoomIndex);
      });
    };
    
    const showZoomImage = (index) => {
      if (index >= 0 && index < totalImages) {
        currentZoomIndex = index;
        zoomImage.src = zoomImages[index].src;
        zoomImage.alt = zoomImages[index].alt;
        updateZoomNavigation();
      }
    };

    if (zoomOverlay) {
      zoomOverlay.addEventListener('click', (e) => {
        const thumbEl = e.target.closest('.sl-zoom-thumb');
        if (!thumbEl) return;
        const thumbsNow = getZoomThumbs();
        const idx = Array.from(thumbsNow).indexOf(thumbEl);
        if (idx >= 0) {
          showZoomImage(idx);
        }
      });
    }
    
    zoomableImages.forEach((img, index) => {
      img.addEventListener('click', (e) => {
        e.preventDefault();
        if (!zoomOverlay) return;
        const mediaId = img.closest('[data-media-id]')?.dataset.mediaId;
        const imageIndex = zoomImages.findIndex(zoomImg => zoomImg.id === mediaId);
        showZoomImage(imageIndex >= 0 ? imageIndex : 0);
        zoomOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    });
    
    if (zoomClose) {
      zoomClose.addEventListener('click', () => {
        zoomOverlay.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
    
    if (zoomPrev) {
      zoomPrev.addEventListener('click', () => {
        if (currentZoomIndex > 0) {
          showZoomImage(currentZoomIndex - 1);
        }
      });
    }
    
    if (zoomNext) {
      zoomNext.addEventListener('click', () => {
        if (currentZoomIndex < totalImages - 1) {
          showZoomImage(currentZoomIndex + 1);
        }
      });
    }
    
    (() => {
      const thumbsNow = getZoomThumbs();
      thumbsNow.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          showZoomImage(index);
        });
      });
    })();
    
    if (zoomOverlay) {
      zoomOverlay.addEventListener('click', (e) => {
        if (e.target === zoomOverlay) {
          zoomOverlay.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
      
      document.addEventListener('keydown', (e) => {
        if (zoomOverlay.style.display !== 'none') {
          if (e.key === 'Escape') {
            zoomOverlay.style.display = 'none';
            document.body.style.overflow = '';
          } else if (e.key === 'ArrowLeft' && currentZoomIndex > 0) {
            showZoomImage(currentZoomIndex - 1);
          } else if (e.key === 'ArrowRight' && currentZoomIndex < totalImages - 1) {
            showZoomImage(currentZoomIndex + 1);
          }
        }
      });
    }
  }

  quantityButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = section.querySelector('.sl-product-quantity-number');
      let val = parseInt(input.value);
      if (btn.classList.contains('sl-product-quantity-plus')) val++;
      else if (val > 1) val--;
      input.value = val;
    });
  });

  optionInputs.forEach(input => input.addEventListener('change', onVariantChange));

  bundleInputs.forEach(input => {
    input.addEventListener('change', () => {
      if (input.checked) {
        const variantId = input.value;
        if (variantSelect) variantSelect.value = variantId;
        const hiddenId = productForm.querySelector('input[name="id"]');
        if(hiddenId) hiddenId.value = variantId;

        if (input.classList.contains('sl-product-subscription-bundle-input')) {
          updateSubscriptionSelection(input);
        } else {

          if (purchaseTypeField) purchaseTypeField.value = 'single';
          if (subscriptionIdField) subscriptionIdField.value = '';
          if (subscriptionServiceField) subscriptionServiceField.value = '';
          if (subscriptionIntervalField) subscriptionIntervalField.value = '';
        }
        
        fetch(`/variants/${variantId}.js`).then(res => res.json()).then(variant => {
          const mainProductAvailable = CFG.productAvailable;
          variant.available = mainProductAvailable;
          updatePriceDisplay(variant);
          updateBuyButtonState(variant);
          updateGallery(variant);

          updateVariantGallery(variantId);

          updateStockWidget(variantId);
          updatePreorderNote(variantData[variantId]);
        });
          
          updatePreorderNote(variantData[variantId]);
      }
    });
  });
  
  async function updateCartDrawer() {
    try {
      const res = await fetch('/?section_id=header');
      const text = await res.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const newDrawer = html.querySelector('.site-header__drawers-container');
      if (newDrawer) {
        const oldDrawer = document.querySelector('.site-header__drawers-container');
        if (oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
        }
      }
    } catch (error) {

    }
  }

  if (productForm) {
    productForm.addEventListener('submit', async e => {
      const vid =
        productForm.querySelector('input[name="id"]')?.value;

      if (variantData[vid]) {
        updatePreorderNote(variantData[vid]);
      }
      e.preventDefault();
      try {
        const formData = new FormData(productForm);
        const payload = {};
        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) {
            if (value) properties[match[1]] = value;
          } else {
            payload[key] = value;
          }
        }
        if (Object.keys(properties).length) payload.properties = properties;
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        const cart = await res.json();

        await updateCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:open'));
      } catch (err) {

      }
    });
  }
  
  CFG.deliveryCountdowns.forEach(function(dc) {
    const el = {
      day: document.getElementById(`delivery-day-${dc.blockId}`),
      date: document.getElementById(`delivery-date-${dc.blockId}`),
      time: document.getElementById(`remaining-time-${dc.blockId}`),
      dot: document.getElementById(`delivery-status-dot-${dc.blockId}`),
      info: document.querySelector(`.sl-product-delivery-countdown[data-block-id="${dc.blockId}"] .sl-product-delivery-info`)
    };
    const s = Object.assign({}, dc.settings);
    s.allowedDays = [0,1,2,3,4,5,6].filter(day => s[`delivery_day_${day}`]);
    const productAvailable = CFG.selectedVariantAvailable;
    const lang = {
      de: {d: ["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"], m: ["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"], M: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"]},
      en: {d: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"], m: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"], M: ["January","February","March","April","May","June","July","August","September","October","November","December"]}
    };
    const l = s.language.startsWith('de') ? lang.de : lang.en;
    function getNextDelivery(start, days) {
      let d = new Date(start);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (s.allowedDays.includes(d.getDay())) added++;
      }
      return d;
    }
    function formatTime(h, m, format) {
      switch (format) {
        case 'hm_colon':
          return `${h}:${m < 10 ? '0' : ''}${m}`;
        case 'std_min':
          return `${h} Std ${m} Min`;
        case 'h_m_small':
          return `${h}h ${m}m`;
        case 'hours_minutes':
          return `${h} Stunden ${m} Minuten`;
        case 'h_m_caps':
        default:
          return `${h}H ${m}M`;
      }
    }

    function update() {

      const currentVariantSelect = section.querySelector('.sl-product-variant-select');
      const currentVariantId = currentVariantSelect ? currentVariantSelect.value : null;
      const currentVariantOption = currentVariantId ? currentVariantSelect.querySelector(`option[value="${currentVariantId}"]`) : null;
      const isCurrentVariantAvailable = currentVariantOption ? currentVariantOption.dataset.available === 'true' : productAvailable;
      
      if (!isCurrentVariantAvailable) {
        if (el.dot) {
          el.dot.style.background = s.unavailable_dot_color;
        }
        if (el.info) {
          el.info.innerHTML = s.unavailable_text;
        }
        return;
      }

      const now = new Date();
      let cutoff = new Date();
      cutoff.setHours(s.delivery_cutoff_time, 0, 0, 0);
      if (now > cutoff) cutoff.setDate(cutoff.getDate() + 1);
      const diff = cutoff - now;
      const h = Math.floor(diff / 36e5);
      const m = Math.floor((diff % 36e5) / 6e4);
      if(el.time) el.time.textContent = formatTime(h, m, s.time_format);
      const deliveryDate = getNextDelivery(cutoff, s.delivery_time_min);
      if(el.day) el.day.textContent = l.d[deliveryDate.getDay()];
      if(el.date) el.date.textContent = `${deliveryDate.getDate()}. ${l.m[deliveryDate.getMonth()]}`;
      if(el.dot) {
        el.dot.style.background = diff > 0 ? s.available_dot_color : s.unavailable_dot_color;
        el.dot.className = 'sl-product-delivery-dot ' + (diff > 0 ? 'sl-dot-delivery-available' : 'sl-dot-delivery-unavailable');
      }
    }

    update();
    setInterval(update, 60000);

    if (el.info && el.info.closest('.sl-product-delivery-countdown')) {
      el.info.closest('.sl-product-delivery-countdown')._updateFunction = update;
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const firstBundle = section.querySelector('.sl-product-bundle-input:checked');
    if (firstBundle) {
      firstBundle.dispatchEvent(new Event('change'));
    } else {
      onVariantChange();
    }

    const currentVariantId = variantSelect ? variantSelect.value : null;
    if (currentVariantId) {
      updateStockWidget(currentVariantId);
    }
  });

  const currentVariantId =
    variantSelect?.value || CFG.selectedVariantId;

  if (variantData[currentVariantId]) {
    updatePreorderNote(variantData[currentVariantId]);
  }

  const tabBtns = section.querySelectorAll('.sl-product-tab-btn');
  const tabContents = section.querySelectorAll('.sl-product-tab-content');
  const subscriptionInputs = section.querySelectorAll('.sl-product-subscription-bundle-input');
  const singleInputs = section.querySelectorAll('.sl-single-bundle-input');

  if (tabBtns.length > 0) {

    tabBtns.forEach((btn, index) => {

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const tabName = this.dataset.tab;

        tabBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        tabContents.forEach(content => {
          content.classList.remove('active');
          if (content.dataset.content === tabName) {
            content.classList.add('active');
          }
        });

        if (purchaseTypeField) {
          if (tabName === 'subscription') {
            purchaseTypeField.value = 'subscription';
            if (buttonTextSingle) buttonTextSingle.style.display = 'none';
            if (buttonTextSubscription) buttonTextSubscription.style.display = 'inline';

            const activeSubscription = section.querySelector('.sl-product-subscription-bundle-input:checked');
            if (activeSubscription) {
              updateSubscriptionSelection(activeSubscription);
            }
          } else {
            purchaseTypeField.value = 'single';
            if (buttonTextSingle) buttonTextSingle.style.display = 'inline';
            if (buttonTextSubscription) buttonTextSubscription.style.display = 'none';

            if (subscriptionIdField) subscriptionIdField.value = '';
            if (subscriptionServiceField) subscriptionServiceField.value = '';
            if (subscriptionIntervalField) subscriptionIntervalField.value = '';

            const activeSingle = section.querySelector('.sl-single-bundle-input:checked') || section.querySelector('.sl-product-bundle-input:checked');
            if (activeSingle && activeSingle.dataset.variantId) {
              updateVariantSelection(activeSingle.dataset.variantId);
            }
          }
        }
      });
    });
  }

  function getRechargePrice(variantId, sellingPlanId) {
    try {

      if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.formattedPrices) {

        const variantData = window.SubscriptionWidgetConfig.formattedPrices[variantId];

        if (variantData && variantData.sellingPlans && variantData.sellingPlans[sellingPlanId]) {
          const planData = variantData.sellingPlans[sellingPlanId];

          const result = {
            price: planData.price,
            originalPrice: variantData.unit,
            discountType: planData.discountType,
            discountValue: planData.discountValue
          };

          return result;
        } else {

        }
      } else {

      }
    } catch (error) {

    }
    return null;
  }

  function updateSubscriptionSelection(input) {
    if (!input) return;
    
    const variantId = input.dataset.variantId || input.value;
    const subscriptionId = input.dataset.subscriptionId;
    const subscriptionService = input.dataset.subscriptionService;
    const subscriptionInterval = input.dataset.subscriptionInterval;
    
    console.log('Updating subscription selection:', {
      variantId,
      subscriptionId,
      subscriptionService,
      subscriptionInterval
    });

    if (subscriptionIdField) subscriptionIdField.value = subscriptionId || '';
    if (subscriptionServiceField) subscriptionServiceField.value = subscriptionService || '';
    if (subscriptionIntervalField) subscriptionIntervalField.value = subscriptionInterval || '';

    if (subscriptionService === 'recharge' && subscriptionId) {

      const priceData = getRechargePrice(variantId, subscriptionId);
      if (priceData) {

        updateSubscriptionPriceDisplay(priceData.price, priceData.originalPrice);
      } else {

      }
    }

    updateVariantSelection(variantId);

    updateVariantGallery(variantId);

    updateStockWidget(variantId);
    updatePreorderNote(variantData[variantId]);
  }

    function updateSubscriptionPriceDisplay(subscriptionPrice, originalPrice) {

    const toCents = (v) => {
        if (v == null) return 0;
        if (typeof v === 'number') return v;           // bereits Cent
        if (typeof v === 'string') return Number(v.replace(/[^\d]/g, '')) || 0;
        if (typeof v === 'object' && typeof v.price === 'number') return v.price;
        return 0;
    };

    const priceCents   = toCents(subscriptionPrice);
    const compareCents = toCents(originalPrice);

    updatePriceDisplay({ price: priceCents, compare_at_price: compareCents });
    }

  function updateVariantSelection(variantId) {

    if (variantSelect && variantId) {
      const option = variantSelect.querySelector(`option[value="${variantId}"]`);

      if (option) {
        variantSelect.value = variantId;

        const hiddenId = productForm.querySelector('input[name="id"]');
        if (hiddenId) {
          hiddenId.value = variantId;

        }

        const changeEvent = new Event('change', { bubbles: true });
        variantSelect.dispatchEvent(changeEvent);

        if (window.updatePrice) {
          window.updatePrice(variantId);
        }

        updateVariantGallery(variantId);

        section.querySelectorAll('.sl-product-delivery-countdown').forEach(countdown => {

          const deliveryUpdate = countdown._updateFunction;
          if (deliveryUpdate) deliveryUpdate();
        });

        updateStockWidget(variantId);
        updatePreorderNote(variantData[variantId]);
      } else {

      }
    } else {

    }
  }

  if (subscriptionInputs.length > 0) {
    subscriptionInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.checked) {
          updateSubscriptionSelection(this);
        }
      });
    });
  }

  if (singleInputs.length > 0) {
    singleInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.checked && this.dataset.variantId) {
          updateVariantSelection(this.dataset.variantId);
        }
      });
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      const currentHandler = e.target.onsubmit;

      const purchaseType = purchaseTypeField ? purchaseTypeField.value : 'single';
      
      if (purchaseType === 'subscription') {
        e.preventDefault(); // Prevent default submission
        
        try {
          const formData = new FormData(this);
          const subscriptionService = formData.get('properties[_subscription_service]');
          const subscriptionId = formData.get('properties[_subscription_id]');

          if (subscriptionService === 'shopify' && subscriptionId) {
            await handleShopifySubscription(formData, subscriptionId);
          } else if (subscriptionService === 'recharge' && subscriptionId) {
            await handleRechargeSubscription(formData, subscriptionId);
          } else {

            await addToCartEnhanced(formData);
          }
        } catch (err) {

          this.submit();
        }
      }

    });
  }

  async function addToCartEnhanced(formData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.fromEntries(formData))
    });
    
    if (res.ok) {

      const data = await res.json();

      if (window.CartDrawer) window.CartDrawer.open();
      if (window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      }

      window.location.href = '/cart';
    } else {
      throw new Error('Failed to add to cart');
    }
  }

  async function handleShopifySubscription(formData, subscriptionId) {
    const subscriptionData = Object.fromEntries(formData);
    subscriptionData['properties[_subscription_type]'] = 'shopify';
    subscriptionData['properties[_shopify_subscription_id]'] = subscriptionId;

    subscriptionData['selling_plan'] = subscriptionId;

    await addToCartEnhanced(new URLSearchParams(subscriptionData));
  }

  async function handleRechargeSubscription(formData, subscriptionId) {

    const rechargeWidget = document.querySelector('recharge-subscription-widget');
    
    if (rechargeWidget) {

      const variantId = formData.get('id') || document.querySelector('input[name="id"]')?.value;

      try {

        if (variantId) {
          rechargeWidget.setAttribute('default-variant-id', variantId);
        }

        const rechargeForm = rechargeWidget.shadowRoot?.querySelector('form') || 
                           document.querySelector('form[data-recharge]') ||
                           rechargeWidget.querySelector('form');
        
        if (rechargeForm) {

          const subscriptionRadio = rechargeWidget.shadowRoot?.querySelector(`input[value="${subscriptionId}"]`) ||
                                  rechargeForm.querySelector(`input[value="${subscriptionId}"]`);
          
          if (subscriptionRadio) {
            subscriptionRadio.checked = true;
            subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }

          rechargeForm.submit();
          return;
        }
      } catch (error) {

      }
    }

    const subscriptionData = Object.fromEntries(formData);
    subscriptionData['selling_plan'] = subscriptionId;
    subscriptionData['properties[_subscription_type]'] = 'recharge';

    await addToCartEnhanced(new URLSearchParams(subscriptionData));
  }

  function initializeRechargeIntegration() {

    const checkRechargeConfig = () => {
      if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.formattedPrices) {

        Object.keys(window.SubscriptionWidgetConfig.formattedPrices).forEach(variantId => {

        });

        const subscriptionInputs = section.querySelectorAll('.sl-product-subscription-bundle-input');
        subscriptionInputs.forEach(input => {
          if (input.checked) {
            updateSubscriptionSelection(input);
          }
        });
      } else {

        setTimeout(checkRechargeConfig, 100);
      }
    };
    
    checkRechargeConfig();
  }

  const activeTab = section.querySelector('.sl-product-tab-btn.active');
  if (activeTab && purchaseTypeField) {
    const currentTab = activeTab.dataset.tab || 'single';
    purchaseTypeField.value = currentTab;
    
    if (currentTab === 'subscription') {
      if (buttonTextSingle) buttonTextSingle.style.display = 'none';
      if (buttonTextSubscription) buttonTextSubscription.style.display = 'inline';

      initializeRechargeIntegration();
      
      const firstSubscription = section.querySelector('.sl-product-subscription-bundle-input:checked');
      if (firstSubscription) {
        updateSubscriptionSelection(firstSubscription);
      }
    } else {
      if (buttonTextSingle) buttonTextSingle.style.display = 'inline';
      if (buttonTextSubscription) buttonTextSubscription.style.display = 'none';
      
      const firstBundle = section.querySelector('.sl-product-bundle-input:checked');
      if (firstBundle && firstBundle.dataset.variantId) {
        updateVariantSelection(firstBundle.dataset.variantId);
      }
    }
  }

  if (tabBtns.length > 0) {
    const subscriptionTab = section.querySelector('.sl-product-tab-btn[data-tab="subscription"]');
    if (subscriptionTab) {
      subscriptionTab.addEventListener('click', () => {
        setTimeout(initializeRechargeIntegration, 100);
      });
    }
  }
})();
